import { render } from "./OpAvatar.vue?vue&type=template&id=7b5a1b99"
import script from "./OpAvatar.vue?vue&type=script&lang=js"
export * from "./OpAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__